const handleInitRelatedSlider = ({ id }) => {
  const carouselId = `related-product-carousel-${id}`;
  const carouselElement = document?.getElementById(carouselId);

  if (!carouselElement) {
    return null;
  }

  const mobileSlides = getSlidesConfig(
    carouselElement.dataset.slidesPerViewMobile,
    SLIDES_PER_VIEW_MOBILE_DEFAULTS
  );
  const desktopSlides = getSlidesConfig(
    carouselElement.dataset.slidesPerViewDesktop,
    SLIDES_PER_VIEW_DESKTOP_DEFAULTS
  );

  const pageWidth = document?.body?.offsetWidth;
  const isDesktop = pageWidth > DESKTOP_WIDTH;
  const { productCount } = carouselElement.dataset;

  // Controls only earn their place when there is a card to scroll to, so the
  // threshold is however many whole cards the merchant's setting shows at this
  // breakpoint — a peek (.1) is not a reachable card.
  const productCountTarget = Math.floor(
    isDesktop ? desktopSlides.slidesPerView : mobileSlides.slidesPerView
  );
  const isEnabledAsBool = productCount > productCountTarget;
  const paginationId = `swiper-pagination-${id}`;
  const paginationEnabled = isEnabledAsBool && {
    pagination: {
      el: `#${paginationId}`,
      type: 'bullets',
    },
  };

  const navigationEnabled = isEnabledAsBool && {
    navigation: {
      nextEl: `#swiper-button-next-${id}`,
      prevEl: `#swiper-button-prev-${id}`,
    },
  };

  if (!isEnabledAsBool) {
    const navigationWrapper = document.getElementById(
      `swiper-navigation-wrapper-${id}`
    );

    navigationWrapper?.classList?.add('!hidden');
  }

  const swiper = new Swiper(`#${carouselId}`, {
    speed: DEFAULT_SLIDER_SPEED,
    loop: false,
    watchOverflow: true, // Disable slider if slides fit within container
    preventInteractionOnTransition: true, // Prevent interactions during slide transitions
    observer: true, // Enable mutation observer
    centeredSlides: false,
    spaceBetween: 16,
    ...mobileSlides,
    breakpoints: {
      [DESKTOP_WIDTH]: {
        spaceBetween: 24,
        ...desktopSlides,
      },
    },
    ...navigationEnabled,
    ...paginationEnabled,
    on: {
      init: function () {
        this?.el?.classList.remove('opacity-0');
        this?.wrapperEl?.classList.remove(
          'items-center',
          'justify-center',
          'gap-4'
        );
      },
    },
    watchOverflow: true,
  });

  return swiper;
};

const handleSetRecommendedData = (section, text, id) => {
  if (!text && !section) {
    return null;
  }

  const html = document.createElement('div');
  html.innerHTML = text;

  const recommendations = html.querySelector(`#${id}`);

  if (recommendations && recommendations.innerHTML.trim().length) {
    section.innerHTML = recommendations.innerHTML;
    handleInitRelatedSlider({
      id: id,
    });
  }
};

const handleInitRecommendedData = (entries, observer) => {
  if (!entries?.[0]?.isIntersecting) {
    return null;
  }

  const { id, url } = entries?.[0]?.target.dataset;
  const productRecommendationsSection = document?.getElementById(id);

  if (!productRecommendationsSection) {
    return null;
  }

  observer.unobserve(productRecommendationsSection);

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      handleSetRecommendedData(productRecommendationsSection, text, id);
    })
    .catch((e) => {
      console.error(e);
    });
};

const handleRelatedObserver = (element) => {
  const viewportHeight = `${Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0
  )}px`;

  const observer = new IntersectionObserver(handleInitRecommendedData, {
    rootMargin: viewportHeight,
  });

  observer.observe(element);
};

const handleInitRelatedProduct = () => {
  const productRecommendationsSection = document?.querySelectorAll(
    '.js-product-recommendations'
  );

  if (productRecommendationsSection?.length == 0) {
    return null;
  }

  productRecommendationsSection.forEach((element) => {
    handleRelatedObserver(element);
  });
};

window.addEventListener('DOMContentLoaded', handleInitRelatedProduct, { once: true });
window.addEventListener('product-info:loaded', handleInitRelatedProduct);

// The section renders empty and fills itself from the recommendations endpoint,
// so a theme editor re-render leaves an empty wrapper that `empty:hidden` keeps
// hidden — DOMContentLoaded has already fired and won't fetch it again. Only the
// section that reloaded is re-observed, to avoid re-fetching sections already on
// the page.
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const reloadedSection = event.target.querySelector(
      '.js-product-recommendations'
    );

    if (reloadedSection) {
      handleRelatedObserver(reloadedSection);
    }
  });
}
